import http from "./http";
import apis from "../config/apis.json";

const api = 
    process.env.REACT_APP_ENVIRON === "development"
    ? apis.dev
    : process.env.REACT_APP_ENVIRON === "production"
    ? apis.prod
    : apis.test;

// Create a new schedule
export async function createSchedule(organizationId, scheduleData) {
    const response = await http.post(`${api}/api/schedule/${organizationId}`, scheduleData);
    return response;
}

// Get schedules for a specific thread
export async function getSchedulesByThreadId(organizationId, threadId) {
    const response = await http.get(`${api}/api/schedule/${organizationId}/thread/${threadId}`);
    return response;
}

// Get all schedules for an organization
export async function getAllSchedules(organizationId) {
    const response = await http.get(`${api}/api/schedule/${organizationId}`);
    return response;
}

// Delete a schedule
export async function deleteSchedule(organizationId, scheduleId) {
    const response = await http.delete(`${api}/api/schedule/${organizationId}/${scheduleId}`);
    return response;
}

// Get schedule run history
export async function getScheduleRunHistory(organizationId, scheduleId) {
    const response = await http.get(`${api}/api/schedule/${organizationId}/${scheduleId}/runs`);
    return response;
}
